<app-breadcrumb [master]="'Administracja'" [parentName]="'Chronie'" [name]="'Komunikaty techniczne'"></app-breadcrumb>

<div class="maintenance-window-list-container" fxLayout="column" fxLayoutGap="15px">
  <div>
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
<!--      <mat-form-field class="maintenance-window-list-filter-long">-->
<!--        <mat-label>UUID</mat-label>-->
<!--        <input matInput [(ngModel)]="initialFilters.uuid" name="uuid">-->
<!--      </mat-form-field>-->

      <mat-form-field class="maintenance-window-list-filter">
        <mat-label>Konfiguracja</mat-label>
        <mat-select [(ngModel)]="initialFilters.enabled" name="enabled">
          <mat-option [value]="1">Włączona</mat-option>
          <mat-option [value]="0">Wyłączona</mat-option>
        </mat-select>
        <button *ngIf="initialFilters.enabled === 1 || initialFilters.enabled === 0"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Wyczyść filtr"
                (click)="initialFilters.enabled = null; $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="maintenance-window-list-filter">
        <mat-label>Baner</mat-label>
        <mat-select [(ngModel)]="initialFilters.noticeEnabled" name="noticeEnabled">
          <mat-option [value]="1">Włączony</mat-option>
          <mat-option [value]="0">Wyłączony</mat-option>
        </mat-select>
        <button *ngIf="initialFilters.noticeEnabled === 1 || initialFilters.noticeEnabled === 0"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Wyczyść filtr"
                (click)="initialFilters.noticeEnabled = null; $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="maintenance-window-list-filter">
        <mat-label>Blokada sprzedaży</mat-label>
        <mat-select [(ngModel)]="initialFilters.blockPurchases" name="blockPurchases">
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>

        <button *ngIf="initialFilters.blockPurchases === 1 || initialFilters.blockPurchases === 0"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Wyczyść filtr"
                (click)="initialFilters.blockPurchases = null; $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="maintenance-window-list-filter">
        <mat-label>Towarzystwo</mat-label>
        <mat-select [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany">
          <mat-option *ngFor="let company of insuranceCompanies" [value]="company.id">
            {{ company.name }}
          </mat-option>
        </mat-select>

        <button *ngIf="initialFilters.insuranceCompany != null && initialFilters.insuranceCompany !== ''"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Wyczyść filtr"
                (click)="initialFilters.insuranceCompany = null; $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <a
      [routerLink]="['/chronie/komunikaty-techniczne/dodaj']"
      [class.disabled-link]="!(userPermissions | async)?.chronie?.admin_root"
      mat-stroked-button
      color="primary">
      <mat-icon>add</mat-icon>
      Dodaj komunikat
    </a>

    <span fxFlex></span>

    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon>
      <span>Szukaj</span>
    </button>

    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon>
      <span>Resetuj filtry</span>
    </button>
  </div>
  <div>
    <table mat-table [dataSource]="items">
      <ng-container matColumnDef="displayFrom">
        <th mat-header-cell *matHeaderCellDef>Wyświetlanie</th>
        <td mat-cell *matCellDef="let element">
          {{ element.displayFrom | date:'dd.MM.yyyy HH:mm' }}<br>
          <span class="secondary-text">
            do {{ element.displayTo ? (element.displayTo | date:'dd.MM.yyyy HH:mm') : 'bezterminowo' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Tytuł</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/chronie/komunikaty-techniczne/szczegoly', element.uuid]">
            {{ element.title }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef>TU</th>
        <td mat-cell *matCellDef="let element">
          {{ element.insuranceCompany?.name || 'Globalny' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startsAt">
        <th mat-header-cell *matHeaderCellDef>Wdrożenie</th>
        <td mat-cell *matCellDef="let element">
          {{ element.startsAt | date:'dd.MM.yyyy HH:mm' }}<br>
          <span class="secondary-text">do {{ element.endsAt | date:'dd.MM.yyyy HH:mm' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="purchaseBlock">
        <th mat-header-cell *matHeaderCellDef>Blokada</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="!element.blockPurchases">Brak</span>
          <span *ngIf="element.blockPurchases">
            {{ element.insuranceCompany?.name || 'Wszystkie towarzystwa' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="getStatus(element).type +'-button'"> {{ getStatus(element).label }}</button>

        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <a
            mat-icon-button
            color="primary"
            matTooltip="Szczegóły"
            [routerLink]="['/chronie/komunikaty-techniczne/szczegoly', element.uuid]">
            <mat-icon>visibility</mat-icon>
          </a>


        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="table-row" mat-row *matRowDef="let element; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="20" [length]="totalData"></mat-paginator>
  </div>
  <app-loading [loading]="loading" [description]="'Pobieranie listy ...'"></app-loading>
</div>
